import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ClientIcon } from 'assets/icon-consulting.svg';
import BackgroundBox from 'shared/components/BackgroundBox';
import { LabelIcon } from 'shared/components/Labels';
import { colors } from 'shared/defaultTheme';

import { addBreadcrumb, removeBreadcrumb } from 'redux/actions/layoutActions';
import useApi from 'hooks/useApi';

import HeaderActions from './components/HeaderActions';
import Table from './components/Table';
import { ClientsWrapper } from './styles';

const Clients = () => {
  const theme = useSelector((state) => state.theme);
  const { breadcrumbs } = useSelector((state) => state.layout);
  const { customAreaApi } = useApi();
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { mainColor } = theme;
  const { selectedDefaultLanguage } = useSelector((state) => state.topBar);
  const [clientStates, setCleintStates] = useState([]);
  const [tagsList, setTagsList] = useState([]);

  const [, getStates] = customAreaApi(
    {
      url: `${window.API_V1}/cus/StatesClients/${auth.cusNavId}`,
      method: 'GET',
      data: {
        filters: [
          {
            model: 'State',
            field: 'Name',
            asc: false,
          },
        ],
        reduce: {
          limit: 0,
          skip: 0,
        },
      },
    },
    { manual: true }
  );

  const [, getTags] = customAreaApi(
    {
      url: `${window.API_V1}/cus/tags/${auth.cusNavId}/search`,
      method: 'POST',
      data: {
        filters: [
          {
            model: 'Tag',
            field: 'Name',
            asc: false,
          },
        ],
        reduce: {
          limit: 0,
          skip: 0,
        },
      },
    },
    { manual: true }
  );

  const getStatesData = async () => {
    const {
      data: { data: states },
    } = await getStates();

    const stateNames =
      states.map((x) => {
        if (!x.i18List) return null;
        const state = x.i18List.find((y) => y.i18Code === selectedDefaultLanguage);
        return {
          text: state?.i18Name || x.i18List[0]?.i18Name || '',
          id: x.id,
          color: x.color,
        };
      }) || [];
    setCleintStates(stateNames);
  };
  const getTagsData = async () => {
    const {
      data: { data: tags },
    } = await getTags();

    const tagNames =
      tags.map((x) => {
        if (!x.i18List) return null;
        const tag = x.i18List.find((y) => y.i18Code === selectedDefaultLanguage);
        return {
          text: tag?.i18Name || x.i18List[0]?.i18Name || '',
          id: x.id,
        };
      }) || [];

    setTagsList(tagNames);
  };

  useEffect(() => {
    getTagsData();
    getStatesData();
  }, [selectedDefaultLanguage]);

  useEffect(() => {
    if (breadcrumbs.length > 1) {
      breadcrumbs.forEach(() => {
        dispatch(removeBreadcrumb());
      });
      dispatch(
        addBreadcrumb({
          active: false,
          label: 'general_home',
          link: '/home',
          isModify: false,
        })
      );
    }
    dispatch(
      addBreadcrumb({
        label: 'home_client_section_label',
        active: true,
        link: pathname,
        isModify: false,
      })
    );
  }, []);

  return (
    <ClientsWrapper className="pb-3">
      <BackgroundBox className="backgroundbox-wrapper">
        <LabelIcon
          label={t('home_client_section_label')}
          Icon={() => <ClientIcon className="label-icon__client" fill={colors.white} />}
          color={mainColor}
          className="text-uppercase ml-1 label-icon"
        />
        <HeaderActions />
        {!!clientStates.length && !!tagsList.length && (
          <Table clientStates={clientStates} tagsList={tagsList} />
        )}
      </BackgroundBox>
    </ClientsWrapper>
  );
};

export default Clients;
